import { render, staticRenderFns } from "./ReviewSection.vue?vue&type=template&id=6d7dc0f4"
import script from "./ReviewSection.vue?vue&type=script&lang=js"
export * from "./ReviewSection.vue?vue&type=script&lang=js"
import style0 from "./ReviewSection.vue?vue&type=style&index=0&id=6d7dc0f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports